/* @ngInject */
const wagonLabels = (
  $filter,
  valueHandler
) => {
  const self = {}

  self.class = 'Wagon'
  self.title = 'Wagons'

  self.fields = {
    id: {
      text: 'Numéro',
      invalid: 'Ce numéro de wagon est invalide',
      messages: {
        exists: 'Ce numéro de wagon existe déjà',
        invalid: 'Ce numéro de wagon est invalide',
        valid: 'Ce numéro de wagon est valide',
      },
    },
    idNew: {
      text: 'Nouveau Numéro',
      invalid: 'Ce numéro de wagon est invalide',
      messages: {
        exists: 'Ce numéro de wagon existe déjà',
        invalid: 'Ce numéro de wagon est invalide',
        valid: 'Ce numéro de wagon est valide',
      },
    },
    type: {
      text: 'Type',
    },
    set: {
      text: 'Série',
    },
    typeAndSet: {
      text: 'Type / Série',
    },
    area: {
      text: 'Zone',
    },
    railway: {
      text: 'Voie',
    },
    trainId: {
      text: 'Id du train',
    },
    train: {
      text: 'Train courant',
    },
    arrivalDate: {
      text: 'Date d\'arrivée',
    },
    departureDate: {
      text: 'Date de départ',
    },
    length: {
      text: 'Longueur (m)',
    },
    tare: {
      text: 'Tare (kg)',
    },
    capacity: {
      text: 'Capacité (L ou m&sup3;)',
    },
    feet: {
      text: 'Nombre de pied',
    },
    brakedMass: {
      text: 'Masse freinée (kg)',
    },
    color: {
      text: 'Couleur',
    },
    step: {
      text: 'Pas',
    },
    revision: {
      text: 'Révision',
    },
    revisionDate: {
      text: 'Date de révision',
    },
    expiredRevisionDate: {
      text: 'Échéance de révision',
    },
    // extendRevision: {
    //   text: '+3M',
    // },
    revisionDateBegin: {
      text: 'Date de révision : ',
    },
    revisionDateEnd: {
      text: 'Jusqu\'au : ',
    },
    revisionDateExpiredBegin: {
      text: 'Date de révision (expiration) : ',
    },
    revisionDateExpiredEnd: {
      text: 'Jusqu\'au : ',
    },
    isolated: {
      text: 'Isolé',
    },
    damaged: {
      text: 'Avarié',
    },
    isolatedComment: {
      text: 'Commentaire isolé',
    },
    damagedComment: {
      text: 'Commentaire avarié',
    },
    case: {
      text: 'Dossier',
    },
    status: {
      text: 'Statut',
    },
    state: {
      text: 'État',
    },
    raadRaat: {
      text: 'RAAD/RAAT',
    },
    archive: {
      text: 'Archive',
    },
    client: {
      text: 'DEG',
    },
    comment: {
      text: 'Commentaire',
    },
    elv: {
      text: 'Elv',
    },
    vt: {
      text: 'Recyclage',
    },
    announceScrapping: {
      text: 'Annoncé en ferraillage',
    },
    scrapped: {
      text: 'Autorisation pour ferraillage',
    },
    revisionBadge: {
      text: 'Badge de révision',
    },
    dateBadge: {
      text: 'Badge de date',
    },
    owner: {
      text: 'Propriétaire',
      choice: 'Choix du propriétaire',
    },
    oldOwner: {
      text: 'Ancien propriétaire',
      choice: 'Choix du propriétaire',
    },
    position: {
      text: 'Position',
    },
    ratioPosition: {
      text: 'Position / total',
    },
    sale: {
      text: 'Nom de la vente',
    },
    salePlace: {
      text: 'Lieu de la vente',
    },
    saleDate: {
      text: 'Date de la vente',
    },
    scrappingDate: {
      text: 'Date de l\'autorisation en ferraillage',
    },
    checkScrapping: {
      text: 'Valider le ferraillage',
    },
    workshop: {
      text: 'Nom d\'atelier',
    },
    dispositionDate: {
      text: 'Date de mise à disposition',
    },
    dateIntervalBegin: {
      text: 'Début de la période de présence',
    },
    dateIntervalEnd: {
      text: 'Fin de la période de présence',
    },
    commande: {
      text: 'Commande',
    },
    photo: {
      text: 'Photos',
    },
  }

  self.statements = {
    notRegister: 'Le wagon n\'est actuellement pas enregistré sur une voie',
    noTrain: 'Le wagon n\'est pas enregistré dans un train.',
    addTrain: 'Ajouter un train',
    calculId: 'Calcul des numéros de wagon',
    verifyId: 'Vérification des numéros de wagon',
    list: 'Liste des wagons',
    incompleteRevision: 'Les informations concernant la révision ne sont pas complètes',
    includeAll: 'Inclure les wagons qui ne sont pas présents sur le site',
    destination: 'Destination',
    add: 'Ajout d\'un wagon',
    addHead: 'Ajout en tête',
    addQueue: 'Ajout en queue',
    waitingList: 'Liste des wagons en attente de garage',
    emptyWaitingList: 'Aucun wagon dans la liste d\'attente',
    side: 'Côté',
    search: 'Rechercher des wagons',
    byId: 'Par Numéro',
    byTrain: 'Par train',
    byOwner: 'Par propriétaire',
    byRail: 'Par voie',
    move: 'Déplacer des wagons',
    maneuverReport: 'Compte rendu de la manœuvre',
    unparkReport: 'Compte rendu du dégarage',
    newManeuver: 'Nouvelle manœuvre',
    newUnpark: 'Nouveau dégarage',
    chooseDestinationRailway: 'Choix de la voie de destination',
    autocontrole: 'Autocontrôle',
    label: (_size = 0, _point = false) => {
      return 'Wagon' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
    number: (_number) => {
      return 'Wagon N° ' + '<span class="no-break">' + _number + '</span>'
    },
    modifyNumber: (_number) => {
      return 'Modifier le wagon N° ' + '<span class="no-break">' + _number + '</span>'
    },
    railwayRegister: (_railwayName, _railwayId, _position) => {
      return '<span>Le wagon est enregistré sur la </span>' +
        '<a href="#"' +
        'ng-click="$$railway.go.consult(' + _railwayId + ')">' +
        'voie ' + _railwayName +
        '</a>' +
        '<span> à la position </span>' +
        '<span>' + _position + '</span>'
    },
    displayTrain: (_train) => {
      if (valueHandler.isEmpty(_train) || !valueHandler.isId(_train.id)) {
        return '<span>Le wagon n\'est lié à aucun train</span>'
      }

      return '<span>Afficher le train : </span>' +
        '<a href=""' +
        'ng-click="$$train.go.consult(' + _train.id + ')">' +
        _train.tractionnaire + ' - ' + $filter('field')(_train.date, 'date') +
        '</a>'
    },
    toggleMovements: (_show) => {
      return (_show ? 'Masquer' : 'Afficher') + ' les mouvements'
    },
    toggleScrapping: (_show) => {
      return (_show ? 'Masquer' : 'Afficher') + ' le ferraillage'
    },
    toggleTrains: (_show) => {
      return (_show ? 'Masquer' : 'Afficher') + ' les trains'
    },
    toggleTrain: (_show) => {
      return (_show ? 'Masquer' : 'Afficher') + ' le train'
    },
    toggleRailway: (_show) => {
      return (_show ? 'Masquer' : 'Afficher') + ' la voie'
    },
    changeTrain: (_id) => {
      return 'Changer le train du wagon ' + _id
    },
    selectTrain: (_selected) => {
      return _selected ? 'Train sélectionné' : 'Sélection du train'
    },
    displayWaitingList: (_length) => {
      return _length > 0 ? self.statements.waitingList : self.statements.emptyWaitingList
    },
    continueWith: (_length) => {
      return 'Continuer avec' + (_length > 1 ? ' les ' : ' ') + _length + (_length > 1 ? ' wagons' : ' wagon')
    },
    numberToPark: (_number = 0) => {
      if (_number > 1) {
        return _number + ' wagons sont en attente de garage.'
      } else if (_number === 1) {
        return '1 wagon est en attente de garage.'
      } else {
        return 'Aucun wagon en attente de garage.'
      }
    },
    meterToPark: (_length = 0) => {
      return _length + ' mètres à garer.'
    },
    lengthToPark: (_length) => {
      return 'Longueur totale à garer : ' + '<strong>' + _length + ' mètres </strong>'
    },
    moveSide: (_side) => {
      if (!valueHandler.isString(_side)) {
        _side = ''
      }
      return 'Déplacer côté ' + _side
    },
    displayWaitingWagons: (_displayed) => {
      return (_displayed ? 'Masquer' : 'Afficher') + ' la liste des wagons en attente'
    },
    searchField: (_fieldName, _fieldValue) => {
      if (_fieldName === 'state') {
        _fieldName = 'état'
      }
      if (_fieldName === 'status') {
        _fieldName = 'statut'
      }
      if (_fieldName === 'client') {
        _fieldName = 'client'
      }
      return 'Les wagons avec "' + _fieldValue + '" comme ' + _fieldName + ' ont été trouvés'
    },
    waitingInvoice: (_length) => {
      if (valueHandler.isNull(_length) || _length === 0) {
        return 'Aucun wagon en attente de factuaration'
      } else if (_length === 1) {
        return '1 wagon en attente de facturation'
      } else {
        return `${_length} wagons en attente de facturation`
      }
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce wagon ? Tous les mouvements associés seront perdus',
    disableScrapped: 'Êtes vous sûr de vouloir retirer l\'autorisation de ferraillage de ce wagon ?',
    enableScrapped: 'Êtes vous sûr de vouloir autoriser le ferraillage de ce wagon ?',
    clearFields: 'Êtes vous sûr de vouloir effacer tous les champs du wagon ?',
    removeFromList: 'Êtes-vous sûr de vouloir retirer ce wagon de la liste ?',
    removeFromTrain: 'Êtes vous sûr de vouloir retirer ce wagon de ce train ?',
    changeTrain: 'Êtes-vous sûr de vouloir changer de train ? Tous les wagons dans la liste d\'attente seront perdus',
    parkAll: (_length) => {
      return 'Êtes-vous sûr de vouloir enregistrer ce train de ' + _length + ' wagon' + (_length > 1 ? 's ?' : ' ?')
    },
  }

  self.log = {
    save: {
      success: 'Le wagon a bien été créé.',
      failure: 'Une erreur est survenue lors de la création du wagon.',
      duplicateWagonId: 'Sauvegarde impossible, il existe déjà un wagon avec le même id.',
      alreadyInList: 'Le wagon est déjà dans la liste.',
      addList: 'Le wagon à été ajouté à la liste.',
      alreadyOnRailway: 'Ce wagon est déjà enregistré sur une voie.',
      saleId: 'Ce wagon appartient déjà à une autre vente.',
      scrapped: 'Ce wagon est déjà ferraillé.',
      recoverData: (_id) => {
        return 'Récupération des informations du wagon ' + _id + '.'
      },
    },
    updateField: {
      failure: 'Impossible de mettre à jour le champ.',
      success: 'Le champ à bien été mis à jour.',
    },
    update: {
      success: 'Le wagon a bien été modifié.',
      failure: 'Une erreur est survenue lors de la modification du wagon.',
    },
    delete: {
      success: 'Le wagon a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du wagon.',
      onRailway: 'Impossible de supprimer un wagon encore positioné sur une voie.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun wagon ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 wagon a été trouvé.'
        } else if (_length > 1) {
          return _length + ' wagons ont été trouvés.'
        }
        return 'Wagon recherché'
      },
      failure: 'Une erreur est survenue durant la recherche des wagons.',
      noResult: 'Aucun wagon ne correspond à cette recherche.',
      noResultOnRailway: 'Aucun wagon n\'est présent sur cette voie.',
      addList: 'Le wagon à été ajouté à la liste.',
      saleId: 'Ce wagon appartient déjà à une autre vente.',
      scrapped: 'Ce wagon n\'est pas autorisé à être ferraillé.',
      invalid: 'Ce numéro de wagon est invalide.',
      notInList: 'Le wagon n\'est pas présent dans la liste.',
      removeFromList: 'Le wagon a été retiré de la liste.',
    },
    searchById: {
      noResult: 'Aucun wagon n\'a été trouvé avec ce numéro.',
      multipleResult: 'Plusieurs wagons ont été trouvé avec ce numéro.'
    },
    park: {
      success: 'Garage effectué avec succès.',
      failure: 'Le garage n\'a pas pu être effectué.',
    },
    move: {
      success: 'Déplacement effectué avec succès.',
      failure: 'Le déplacement n\'a pas pu être effectué.',
    },
    unpark: {
      success: 'Dégarage effectué avec succès.',
      failure: 'Le dégarage n\'a pas pu être effectué.',
      alreadyAssigned: 'Ce train a déjà été assigné au wagon'
    },
    scrap: {
      success: 'La modification du statut du wagon pour le ferraillage a réussi.',
      alreadyScrapped: 'Le wagon est déjà ferraillé, impossible de changer son statut.',
      failure: 'Impossible de changer le statut de ferraillage de ce wagon.',
    },
    enableScrapping: {
      success: 'La wagon est prêt à être ferrailler.',
      alreadyScrapped: 'Le wagon est déjà ferraillé, impossible de changer son statut.',
      failure: 'Impossible de ferrailler ce wagon.',
    },
    checkScrapping: {
      success: (bool) => 'Le ferraillage de ce wagon est ' + (bool ? 'validé.' : 'annulé'),
      error: 'Impossible de valider le ferraillage de ce wagon',
    },
    renameWagon: {
      success: 'Le nouveau numéro a bien été supprimé du wagon',
      error: 'Impossible de renommer le wagon',
    },
    removeLastDisposition: {
      success: 'Les dernières mises à disposition des wagons ont été supprimées',
      error: 'Impossible de supprimer les mises à disposition des wagons',
    },
  }

  self.badge = {
    isolated: 'isolé',
    damaged: 'avarié',
    revision: 'revision',
    date: 'date',
    comment: 'commentaire',
    scrapping: 'ferraillé',
  }

  return self
}

export default wagonLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/resources/labels.resource.js